<template>
<div>
    <div class="large-8 columns left" id="home-page">
      <headline></headline>
      <newsListPanel></newsListPanel>
    </div>
    <div class="large-4 columns right">
      <activityPanel v-if="isLogged" ></activityPanel>
      <latestMatchesPanel v-if="isLogged" ></latestMatchesPanel>
      <loginPanel v-if="!isLogged"></loginPanel>
      <registerPanel v-if="!isLogged"></registerPanel>
    </div>
</div>
</template>

<script>
import headline from './headline.vue'
import newsListPanel from './news-list-panel.vue'
import rankingPanel from './ranking-panel.vue'
import loginPanel from './login-panel.vue'
import registerPanel from './register-panel.vue'
import latestMatchesPanel from './latest-matches-panel.vue'
import activityPanel from './activity-panel.vue'
import { mapGetters } from 'vuex'
import store from '../../store/index.js'
export default {
  name: 'home',
  components: {
    headline,
    rankingPanel,
    loginPanel,
    registerPanel,
    latestMatchesPanel,
    newsListPanel,
    activityPanel
  },
  computed:
  {
    ...mapGetters([
      'isLogged',
      'activatedLeague'
    ])
  },
  created () {
    store.dispatch('showLeaguePanel')
    store.dispatch('deactivateFullSizePage')
  },
  data () {
    return {
      username: 'le gros beeeg'
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// home.vue?0dfecf4e